import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { FmIcon } from "../../../Components";
import { useIsMobile, useTheme } from "../../../Hooks";
import { AgriSolutionState, SavedItemsState, GeneralState } from "../../../Redux/States";
import BottomDrawer from "../BottomDrawer/BottomDrawer";

import useStyles from "./SavedItem.style";
import { LOGGED_IN_ROUTES } from "../../../Constants";
import { useHistory } from "react-router-dom";
import { ZERO, FIVE } from "../../../Utils/Consts";

interface savedItemProps {
  id: number;
  title: string;
  date: string;
  area: string;
  onDelete?: any;
  onDuplicate: (itemId: number) => void;
  onRename: (itemId: number, newName: string) => void;
}

const SavedItem = ({ id, title, date, area, onDelete, onDuplicate, onRename }: savedItemProps) => {
  const classes = useStyles();
  const theme = useTheme();
  const isMobile = useIsMobile();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const history = useHistory();
  const [showInput, setShowInput] = useState(false);
  const [inputValue, setInputValue] = useState(title);

  const onRenameHandler = (e: any) => {
    e.preventDefault();
    onRename(id, inputValue);
    setShowInput(false);
  };
  const stepIndexPage = useSelector(AgriSolutionState.Selectors.selectStepIndexPage);
  const openSavedItemHandler = async (e: any) => {
    const response = await dispatch(
      SavedItemsState.Thunks.getSavedItemById(id, () => {
        //
      }),
    );
    navigateToSavedItemPath(response);
  };

  const navigateToSavedItemPath = (response: any) => {
    if (response && response.data) {
      dispatch(
        GeneralState.Actions.setGreenBar({
          isShow: isStepIndexValid(response.data.step),
          lastIsShow: false,
        }),
      );
      dispatch(AgriSolutionState.Actions.setReleaseGraphType(response.data.displayReadyMadeGraphType));
    }
    if (response && response.data) {
      switch (response.data.step) {
        case 0:
          history.push(LOGGED_IN_ROUTES.AGRI_SOLUTION_FIRST_STEP);
          break;
        case 1:
          history.push(LOGGED_IN_ROUTES.AGRI_SOLUTION_SECOND_STEP);
          break;
        case 2:
          history.push(LOGGED_IN_ROUTES.AGRI_SOLUTION_THIRD_STEP);
          break;
        case 3:
          history.push(LOGGED_IN_ROUTES.AGRI_SOLUTION_FORTH_STEP);
          break;
        case 4:
          history.push(LOGGED_IN_ROUTES.AGRI_SOLUTION_FIFTH_STEP);
          break;
        case 5:
          response.data.isAgriItem ? history.push(LOGGED_IN_ROUTES.AGRI_SOLUTION_RELEASE_CHART) : history.push(LOGGED_IN_ROUTES.SOLUTION_SECOND_STEP);
          break;
        default:
          console.log("saved item switch", stepIndexPage);
          break;
      }
    }
  };
  const isStepIndexValid = (index: number) => {
    return index >= ZERO && index <= FIVE;
  };
  const onDelete_ = (e: any, itemId: number) => {
    // e.stopImmediatePropagation();
    //e.preventDefault();
    onDelete(itemId);
  };
  return (
    <div className={isMobile ? classes.mobile_container : classes.container}>
      <div className={isMobile ? classes.mobile_firstRow : classes.firstRow}>
        <div className={classes.firstRow_left_container}>
          {showInput && (
            <form onSubmit={onRenameHandler}>
              <input
                onBlurCapture={onRenameHandler}
                className={classes.inputClass}
                value={inputValue}
                onChange={(e) => setInputValue(e.target.value)}
              />
            </form>
          )}
          {!showInput && <span className={classes.boldTitle}>{title}</span>}
          {!isMobile && !showInput && (
            <FmIcon
              url={theme.images.rename}
              title={t("saveItemsPage.savedItemCard.rename")}
              className={classes.renameIcon}
              onClick={() => setShowInput((prev) => !prev)}
            />
          )}
        </div>
        {isMobile ? (
          <BottomDrawer imgUrl={theme.images.more}>
            <div className={classes.bottomDrawer_container}>
              <span className={classes.bottomDrawer_span} onClick={() => setShowInput((prev) => !prev)}>
                {t("saveItemsPage.savedItemCard.rename")}
              </span>
              <span className={classes.bottomDrawer_span} onClick={() => onDelete_(event, id)}>
                {t("saveItemsPage.savedItemCard.delete")}
              </span>
              <span onClick={() => onDuplicate(id)} className={classes.bottomDrawer_span}>
                {t("saveItemsPage.savedItemCard.duplicate")}
              </span>
            </div>
          </BottomDrawer>
        ) : (
          <div className={classes.firstRow_right_container}>
            <FmIcon url={theme.images.duplicate} title={t("saveItemsPage.savedItemCard.duplicate")} onClick={() => onDuplicate(id)} />
            <FmIcon url={theme.images.delete} title={t("saveItemsPage.savedItemCard.delete")} onClick={() => onDelete_(event, id)} />
          </div>
        )}
      </div>

      <div className={isMobile ? classes.mobile_secondRow : classes.secondRow}>
        <span>{date}</span>
      </div>
      <div className={classes.thirdRow}>
        <span>{area}</span>
        <div onClick={(e) => openSavedItemHandler(e)}>
          <FmIcon url={theme.images.arrow} title={""} />
        </div>
      </div>
    </div>
  );
};

export default SavedItem;
